<template>
  <el-container class="login_container">
    <el-header style="height: 55px">
      <!--Header-->
      <login-header></login-header>
    </el-header>
    <el-main>
      <!--Main Content-->
      <router-view v-if="isRouterAlive" />
    </el-main>
    <el-footer style="height: 150px" class="footer" v-if="false">
      <!--Footer-->
      <login-footer :language="language"></login-footer>
    </el-footer>
  </el-container>
</template>
<script>
import LoginHeader from "../components/layout/LoginHeader";
import LoginFooter from "../components/layout/LoginFooter";
import { getUrlParam } from "../utils/utils";
export default {
  data() {
    return {
      language: getUrlParam("langcode"),
      isRouterAlive: true
    };
  },
  components: {
    LoginHeader,
    LoginFooter
  },
  mounted() {
    this.init();
  },
  beforeRouteUpdate(to, from, next) {
    next();
    this.init();
  },
  methods: {
    changeLang(lang) {
      let _this = this;
      _this.$i18n.locale = lang;
      _this.language = lang;
      // _this.reload();
    },
    init() {
      let lang = getUrlParam("langcode");
      if (lang) {
        this.changeLang(lang);
      } else {
        this.changeLang("EN");
      }
    },
    reload() {
      let _this = this;
      _this.isRouterAlive = false;
      _this.$nextTick(() => (_this.isRouterAlive = true));
    }
  }
};
</script>
<style scoped>
.login_container {
  height: 100%;
}
</style>